import React from 'react';
import { useLocation } from 'react-router-dom';
import { LoadingSpinner } from '../components/common';

const SearchPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get('q') || '';
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold mb-6">
        Search Results for "{searchQuery}"
      </h1>
      
      <div className="py-8 text-center">
        <p className="text-gray-500 mb-4">Search functionality is currently being updated.</p>
        <p className="text-gray-700">Please check back soon for improved search results.</p>
      </div>
    </div>
  );
};

export default SearchPage; 